export { default as BankslipContent } from './BankslipContent';
